module.exports = __webpack_public_path__ + "img/AdobeStock_427679804.60943a6b.jpeg";